import serviceApi from 'services/api';
import auth from 'services/auth';

const api = process.env.REACT_APP_ENVIRONMENT === 'local' ? auth : serviceApi;

export type UpdateWalletCardStatusProps = {
  status: string;
};

/* The function `updateWalletCardStatus` is an asynchronous function that makes a PUT request to the `/apiv1/admin/wavelynx-wallet/cards/${uuid}/status` 
endpoint to update the status of a Wavelynx wallet card. */
const updateWalletCardStatus = async (uuid: string, status: UpdateWalletCardStatusProps) => {
  const response = await api.put(`/apiv1/admin/wavelynx-wallet/cards/${uuid}/status`, status);
  return response?.data;
};

const WavelynxWalletService = {
  updateWalletCardStatus
};

export default WavelynxWalletService;
